import { P2GBox, P2GDropdown, P2GGrid, P2GLink, P2GText } from '@parcel2go/core-ui';
import { ReactNode, useMemo, useState } from 'react';
import { GenerateNumbers } from '../../../lib/helpers/ArrayHelper';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { ParcelCountItem } from './ParcelCountItem';

interface props {
  availableParcels: number;
  selected: number;
  onSelect: (count: number) => void;
  helperText?: ReactNode;
  justify?: 'flex-start' | 'center' | 'flex-end' | 'space-between' | 'space-around' | 'space-evenly';
}

const cutOff = 10;

export const ParcelCountPicker: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  const [showMore, setShowMore] = useState(props.selected > cutOff);
  const options = useMemo(() => {
    if (props.availableParcels <= 0) {
      return [];
    }
    return GenerateNumbers(1, props.availableParcels);
  }, [props.availableParcels]);

  const justify = props.justify ?? 'center';

  if (options.length <= 1) {
    return null;
  }

  return (
    <P2GBox textAlign={justify === 'center' ? 'center' : undefined} p={1}>
      <P2GGrid container alignItems="baseline" justify={justify}>
        {options.slice(0, cutOff).map((o) => (
          <P2GGrid item key={o}>
            <ParcelCountItem
              o={o}
              showFaded={o != props.selected}
              size={o == props.selected ? 'md' : 'sm'}
              onSelect={props.onSelect}
              t={t}
            />
          </P2GGrid>
        ))}
      </P2GGrid>
      {options.length > cutOff && (
        <P2GBox py={1}>
          {showMore ? (
            <P2GDropdown
              fullWidth={false}
              options={options.map((o) => {
                return { value: o.toString() };
              })}
              value={`${props.selected}`}
              id="Parcel Options"
              onChange={(x) => props.onSelect(Number(x))}
            />
          ) : (
            <P2GLink onClick={() => setShowMore(true)}>{t('SHOW_MORE_LINK', { defaultValue: 'Show more' })}</P2GLink>
          )}
        </P2GBox>
      )}
      {props.helperText !== null && (
        <P2GBox mt={1}>
          <P2GText variant="body2">
            {props.helperText ?? t('BOX_COUNT_HELPER_TEXT', { defaultValue: 'How many boxes will you be sending?' })}
          </P2GText>
        </P2GBox>
      )}
    </P2GBox>
  );
};
